import styled from 'styled-components';
import { ButtonLink } from 'fe-appdir-comp-button';

const AppCardButtonLink = styled(ButtonLink)`
  display: block;
  margin: 18px 0 0;
  text-align: center;
`;

AppCardButtonLink.displayName = 'AppCardButtonLink';

export { AppCardButtonLink };
